<template>
    <!--补差价子组件-->
    <div
            v-if="visible"
            class="upgrade-diff-box"
            @click="handleClick"
    >
        {{ textPrefix }}{{ displayPrice(upgradeInfo.upgradePrice) }}元
        <span v-if="countdownText">（剩余{{ countdownText }}）</span>
    </div>
</template>

<script>
    import http from "../utils/http.js";

    export default {
        name: "VipUpgradeDiffBanner",
        emits: ["select"],
        props: {
            userId: {
                type: [String, Number],
                default: null
            },
            textPrefix: {
                type: String,
                default: "限时补差价升级永久会员："
            },
            autoHide: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                upgradeInfo: null,
                countdownText: "",
                countdownTimer: null,
                loading: false
            };
        },
        computed: {
            visible() {
                return !!(this.upgradeInfo && this.upgradeInfo.canUpgrade);
            }
        },
        methods: {
            displayPrice(val) {
                if (val === null || val === undefined || val === "") return "";
                const num = Number(val);
                return Number.isInteger(num) ? num : num.toFixed(2);
            },

            loadData() {
                if (!this.userId || this.loading) return;

                this.loading = true;

                http.get(`/platform/frontEndPayment/permanentUpgradeInfo?userid=${this.userId}`)
                    .then((response) => {
                        const res = response.data;
                        if (res && res.status === 1 && res.data) {
                            this.upgradeInfo = res.data;

                            if (this.upgradeInfo.canUpgrade) {
                                this.startCountdown(this.upgradeInfo.remainingSeconds);
                            } else {
                                this.clearCountdown();
                                if (this.autoHide) {
                                    this.upgradeInfo = null;
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        console.error("获取补差价信息失败:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            refresh() {
                this.loadData();
            },

            startCountdown(seconds) {
                this.clearCountdown();

                let remain = Number(seconds || 0);
                if (remain <= 0) {
                    this.countdownText = "";
                    return;
                }

                const formatTime = (s) => {
                    const h = Math.floor(s / 3600);
                    const m = Math.floor((s % 3600) / 60);
                    const sec = s % 60;
                    return `${h}小时${m}分${sec}秒`;
                };

                this.countdownText = formatTime(remain);

                this.countdownTimer = setInterval(() => {
                    remain--;
                    if (remain <= 0) {
                        this.clearCountdown();
                        this.upgradeInfo = null;
                        return;
                    }
                    this.countdownText = formatTime(remain);
                }, 1000);
            },

            clearCountdown() {
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                }
                this.countdownText = "";
            },

            handleClick() {
                if (!this.upgradeInfo || !this.upgradeInfo.canUpgrade) return;

                this.$emit("select", {
                    type: "限时补差价升级永久会员",
                    amount: this.displayPrice(this.upgradeInfo.upgradePrice),
                    upgradeInfo: this.upgradeInfo
                });
            }
        },
        mounted() {
            this.loadData();
        },
        beforeUnmount() {
            this.clearCountdown();
        }
    };
</script>

<style scoped>
    .upgrade-diff-box {
        display: inline-block;
        background: #d72638;
        color: #fff;
        padding: 10px 14px;
        border-radius: 4px;
        font-size: 0.95rem;
        font-weight: bold;
        cursor: pointer;
        margin-bottom: 10px;
        line-height: 1.5;
    }

    .upgrade-diff-box:hover {
        opacity: 0.92;
    }
</style>
